import script from "./FirmsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./FirmsView.vue?vue&type=script&lang=ts&setup=true"

import "./FirmsView.vue?vue&type=style&index=0&id=36aa755a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36aa755a"]])

export default __exports__